<template>
  <div class="ai-support-box">
    <img src="@/assets/images/funding/icon-ai_supporter.svg" alt="ai 아이콘">
    <p class="ml-3 mb-0" v-html="xaiMsg"></p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: {
        t0: `
          투자하려는 상점의 지난
          <span style="color: #0AA3F1;">지난달 매출</span>과
          <span style="color: #B50AF1;">AI가 예상한 다음달 매출</span>을 확인
          해보세요!
        `,
        t1: `
          <span style="color: #B50AF1;">펀다AI</span> 매출 예측 모델에 일반적으로 중요하게 사용된 요인들에 대한 설명을 확인해보세요!
        `,
        t2: `
          상점별로 매출 예측 모델에 영향을 미친 요소들에 대한 <span style="color: #B50AF1;">펀다AI</span> 설명을 확인해보세요!
        `,
        t3: `
          상점별로 매출 예측 모델에 영향을 미친 요소들이 <span class="font-weight-bold">개선되었을때</span>
          <span style="color: #B50AF1;">펀다AI</span> 예측이 <span class="font-weight-bold">어떻게 긍정적으로 바뀔수 있는지</span> 확인해보세요!
        `,
        t4: `
          상점별로 매출 예측 모델에 영향을 미친 요소들이 <span class="font-weight-bold">개선되었을때</span>
          <span style="color: #B50AF1;">펀다AI</span> 예측이 <span class="font-weight-bold">어떻게 긍정적으로 바뀔수 있는지</span> 확인해보세요!
        `,
      }
    }
  },
  computed: {
    xaiMsg() {
      const { params } = this.$route
      const group = params?.group || 't0'
      return this.msg[group]
    },
  },
}
</script>

<style lang="scss" scoped>
.ai-support-box {
  display: flex;
  align-items: center;

  background-color: #ffffff;
  border-radius: 8px;

  padding: 10px 16px;

  p {
    font-size: 13px;
    line-height: 1.3;
    word-break: break-all;
  }

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
}
</style>
